// extracted by mini-css-extract-plugin
module.exports = {"main":"Form_main__nQI8u","form":"Form_form__7e5il","btn":"Form_btn__eQU3a"};